function emitWarning() {
    if (!emitWarning.warned) {
      emitWarning.warned = true;
      console.log(
        'Deprecation (warning): Using file extension in specifier is deprecated, use "highlight.js/lib/languages/makefile" instead of "highlight.js/lib/languages/makefile.js"'
      );
    }
  }
  emitWarning();
    module.exports = require('./makefile.js');